import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info' | 'loading';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
  showToast: (message: string, type?: ToastType, duration?: number) => string;
  dismissToast: (id: string) => void;
  clearToasts: () => void;
}

const getDefaultDuration = (type: ToastType) => {
  if (type === 'loading') return undefined;
  if (type === 'error') return 6000;
  return 4000;
};

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  showToast: (message, type = 'info', duration) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const toast: Toast = {
      id,
      message,
      type,
      duration: duration ?? getDefaultDuration(type),
    };
    set((state) => {
      const nextToasts = [...state.toasts, toast];
      return { toasts: nextToasts.slice(-5) };
    });
    return id;
  },
  dismissToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    })),
  clearToasts: () => set({ toasts: [] }),
}));
